import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "cache-page" };
const _hoisted_2 = { class: "cache-content" };
const _hoisted_3 = {
    key: 0,
    class: "stats-container"
};
const _hoisted_4 = { class: "stats-row" };
const _hoisted_5 = { class: "stats-main" };
const _hoisted_6 = { class: "card stats-card" };
const _hoisted_7 = { class: "card-title title-with-action" };
const _hoisted_8 = { class: "stats-table" };
const _hoisted_9 = {
    key: 0,
    class: "spinner spinner-small"
};
const _hoisted_10 = { class: "card actions-card" };
const _hoisted_11 = { class: "action-row" };
const _hoisted_12 = { class: "input-group" };
const _hoisted_13 = { class: "action-row" };
const _hoisted_14 = { class: "input-group" };
const _hoisted_15 = { class: "action-row button-group" };
const _hoisted_16 = ["disabled"];
const _hoisted_17 = { class: "stats-sidebar" };
const _hoisted_18 = { class: "card metric-card" };
const _hoisted_19 = { class: "metric-value success" };
const _hoisted_20 = { class: "card metric-card" };
const _hoisted_21 = { class: "metric-value danger" };
const _hoisted_22 = { class: "card metric-card" };
const _hoisted_23 = ["disabled"];
const _hoisted_24 = {
    key: 1,
    class: "loading-container"
};
const _hoisted_25 = { class: "card filter-card" };
const _hoisted_26 = { class: "filter-row" };
const _hoisted_27 = { class: "filter-input" };
const _hoisted_28 = { class: "request-input" };
const _hoisted_29 = { class: "input-group" };
const _hoisted_30 = { class: "log-header" };
const _hoisted_31 = { class: "log-viewer" };
const _hoisted_32 = ["innerHTML"];
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useRoute } from 'vue-router';
import { useAdmin } from '@/composables/useAdmin';
const MAX_LOG_LINES = 700;
export default /*@__PURE__*/ _defineComponent({
    __name: 'CachePage',
    setup(__props) {
        const route = useRoute();
        const admin = useAdmin();
        const stats = ref(null);
        const log = ref([]);
        const interval = ref(null);
        const countInterval = ref(null);
        const filterText = ref('');
        const requestUrl = ref('');
        const flushUrl = ref('');
        const deleteUrl = ref('');
        const emptyRefreshes = ref(0);
        const queueCount = ref(null);
        const locked = ref(true);
        const isFullscreen = ref(false);
        const filteredLog = computed(() => {
            if (!filterText.value)
                return log.value;
            const filter = filterText.value.toLowerCase();
            return log.value.filter((entry) => entry.toLowerCase().includes(filter));
        });
        function getStats() {
            admin.getCacheStats((result) => {
                stats.value = result;
            });
        }
        function getQueueCount() {
            admin.getQueueCount((result) => {
                queueCount.value = result;
            });
        }
        function clearCache() {
            admin.clearCache((result) => {
                stats.value = result;
            });
        }
        function clearStats() {
            admin.clearCacheStats(() => {
                getStats();
            });
        }
        function processQueue() {
            admin.processQueue((result) => {
                stats.value = result;
            });
        }
        function makeRequest(url) {
            admin.getCachedUrl(url, (result) => {
                console.log(result);
                const json = JSON.stringify(result, null, 2);
                log.value.unshift(json);
            });
        }
        function makeFlushRequest(url) {
            admin.flushUrl(url, (result) => {
                console.log(result);
                const json = JSON.stringify(result, null, 2);
                log.value.unshift(json);
            });
        }
        function makeDeleteRequest(url) {
            admin.deleteUrl(url, (result) => {
                console.log(result);
                const json = JSON.stringify(result, null, 2);
                log.value.unshift(json);
            });
        }
        function getLog() {
            admin.getCacheLog((result) => {
                const newEntries = result.filter((entry) => !log.value.includes(entry));
                if (newEntries.length === 0) {
                    emptyRefreshes.value++;
                    if (emptyRefreshes.value == 7) {
                        log.value.unshift('----------------- AUTO MARK -----------------');
                    }
                }
                else {
                    emptyRefreshes.value = 0;
                }
                log.value = [...newEntries, ...log.value].slice(0, MAX_LOG_LINES);
            });
        }
        function refresh() {
            queueCount.value = null;
            getStats();
            getQueueCount();
            getLog();
        }
        function onLoad() {
            getStats();
            getQueueCount();
            getLog();
            interval.value = setInterval(() => {
                getStats();
                getLog();
            }, 3000);
            countInterval.value = setInterval(() => {
                getQueueCount();
            }, 60000);
        }
        function toggleFullscreen() {
            isFullscreen.value = !isFullscreen.value;
        }
        function highlightHit(entry) {
            return entry.replace(/\bHIT\b/g, '<span class="text-hit">HIT</span>')
                .replace(/----------------- MARK -----------------/g, '<span class="text-mark">----------------- MARK -----------------</span>')
                .replace(/----------------- AUTO MARK -----------------/g, '<span class="text-mark">----------------- AUTO MARK -----------------</span>')
                .replace(/\bMISS\b/g, '<span class="text-danger">MISS</span>')
                .replace(/\bPROCESS QUEUE\b/g, '<span class="text-process">PROCESS QUEUE</span>')
                .replace(/\bFLUSH\b/g, '<span class="text-warning">FLUSH</span>')
                .replace(/\bQUEUE\b/g, '<span class="text-queue">QUEUE</span>')
                .replace(/\bCLEARED ALL\b/g, '<span class="text-del">CLEARED ALL</span>')
                .replace(/\bCLEARED STATS\b/g, '<span class="text-success">CLEARED STATS</span>')
                .replace(/\bDELETE\b/g, '<span class="text-del">DELETE</span>')
                .replace(/\bEXCEPTION\b/g, '<span class="text-exception">EXCEPTION</span>')
                .replace(/\bSERVICE STARTED\b/g, '<span class="text-success">SERVICE STARTED</span>')
                .replace(/(https?:\/\/[^\s]+)/g, '<span class="text-info">$1</span>')
                .replace(/(.*\*.*)/g, '<span class="text-remoteinfo">$1</span>')
                .replace(/(took \d+\.?\d* ms)/g, '<span class="text-warning">$1</span>') + "<br/>";
        }
        onMounted(() => {
            onLoad();
            locked.value = route.query.unlock !== 'true';
        });
        onBeforeUnmount(() => {
            if (interval.value) {
                clearInterval(interval.value);
            }
            if (countInterval.value) {
                clearInterval(countInterval.value);
            }
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (stats.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("h5", _hoisted_7, [
                                            _cache[11] || (_cache[11] = _createTextVNode("Cache Details ")),
                                            _createVNode(_component_v_icon, {
                                                class: "refresh-icon",
                                                size: "20",
                                                onClick: _cache[0] || (_cache[0] = ($event) => (refresh()))
                                            }, {
                                                default: _withCtx(() => _cache[10] || (_cache[10] = [
                                                    _createTextVNode("mdi-refresh")
                                                ])),
                                                _: 1
                                            })
                                        ]),
                                        _createElementVNode("table", _hoisted_8, [
                                            _createElementVNode("tbody", null, [
                                                _createElementVNode("tr", null, [
                                                    _cache[12] || (_cache[12] = _createElementVNode("th", null, "Routed API Calls", -1)),
                                                    _createElementVNode("td", null, _toDisplayString(stats.value.calls), 1)
                                                ]),
                                                _createElementVNode("tr", null, [
                                                    _cache[13] || (_cache[13] = _createElementVNode("th", null, "Flushes", -1)),
                                                    _createElementVNode("td", null, _toDisplayString(stats.value.flushes), 1)
                                                ]),
                                                _createElementVNode("tr", null, [
                                                    _cache[14] || (_cache[14] = _createElementVNode("th", null, "Deletes", -1)),
                                                    _createElementVNode("td", null, _toDisplayString(stats.value.deletes), 1)
                                                ]),
                                                _createElementVNode("tr", null, [
                                                    _cache[15] || (_cache[15] = _createElementVNode("th", null, "Queues", -1)),
                                                    _createElementVNode("td", null, _toDisplayString(stats.value.queues), 1)
                                                ]),
                                                _createElementVNode("tr", null, [
                                                    _cache[16] || (_cache[16] = _createElementVNode("th", null, "Queue Processes", -1)),
                                                    _createElementVNode("td", null, _toDisplayString(stats.value.queueProcesses), 1)
                                                ]),
                                                _createElementVNode("tr", null, [
                                                    _cache[17] || (_cache[17] = _createElementVNode("th", null, "Hits", -1)),
                                                    _createElementVNode("td", null, _toDisplayString(stats.value.hits), 1)
                                                ]),
                                                _createElementVNode("tr", null, [
                                                    _cache[18] || (_cache[18] = _createElementVNode("th", null, "Queue Length", -1)),
                                                    _createElementVNode("td", null, [
                                                        (queueCount.value === null)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_9))
                                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                _createTextVNode(_toDisplayString(queueCount.value), 1)
                                                            ], 64))
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("div", _hoisted_11, [
                                            _createElementVNode("div", _hoisted_12, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((flushUrl).value = $event)),
                                                    type: "text",
                                                    placeholder: "Flush a URL",
                                                    class: "form-input"
                                                }, null, 512), [
                                                    [_vModelText, flushUrl.value]
                                                ]),
                                                _createElementVNode("button", {
                                                    class: "btn btn-primary",
                                                    onClick: _cache[2] || (_cache[2] = ($event) => (makeFlushRequest(flushUrl.value)))
                                                }, " Flush ")
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_13, [
                                            _createElementVNode("div", _hoisted_14, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((deleteUrl).value = $event)),
                                                    type: "text",
                                                    placeholder: "Delete a URL (supports *)",
                                                    class: "form-input"
                                                }, null, 512), [
                                                    [_vModelText, deleteUrl.value]
                                                ]),
                                                _createElementVNode("button", {
                                                    class: "btn btn-primary",
                                                    onClick: _cache[4] || (_cache[4] = ($event) => (makeDeleteRequest(deleteUrl.value)))
                                                }, " Delete ")
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_15, [
                                            _createElementVNode("button", {
                                                class: "btn btn-primary",
                                                onClick: _cache[5] || (_cache[5] = ($event) => (log.value.unshift('----------------- MARK -----------------')))
                                            }, " Mark "),
                                            _createElementVNode("button", {
                                                class: "btn btn-primary",
                                                onClick: _cache[6] || (_cache[6] = ($event) => (processQueue()))
                                            }, " Process Queue "),
                                            _createElementVNode("button", {
                                                class: "btn btn-danger",
                                                disabled: locked.value,
                                                onClick: clearCache
                                            }, " Clear Cache ", 8, _hoisted_16)
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("div", _hoisted_18, [
                                        _cache[19] || (_cache[19] = _createElementVNode("h5", null, "Hit Rate", -1)),
                                        _createElementVNode("div", _hoisted_19, _toDisplayString(stats.value.hits) + " (" + _toDisplayString(Number(stats.value.hitRate).toFixed(2)) + ")", 1),
                                        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "metric-label" }, "Cache Efficiency", -1))
                                    ]),
                                    _createElementVNode("div", _hoisted_20, [
                                        _cache[21] || (_cache[21] = _createElementVNode("h5", null, "Misses", -1)),
                                        _createElementVNode("div", _hoisted_21, _toDisplayString(stats.value.misses), 1),
                                        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "metric-label" }, "Excluding Flush Based", -1))
                                    ]),
                                    _createElementVNode("div", _hoisted_22, [
                                        _createElementVNode("button", {
                                            class: "btn btn-danger",
                                            disabled: locked.value,
                                            onClick: clearStats
                                        }, " Reset Stats ", 8, _hoisted_23)
                                    ])
                                ])
                            ])
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_24, _cache[23] || (_cache[23] = [
                            _createElementVNode("div", { class: "spinner" }, null, -1)
                        ]))),
                    _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((filterText).value = $event)),
                                    type: "text",
                                    placeholder: "Filter log entries...",
                                    class: "form-input"
                                }, null, 512), [
                                    [_vModelText, filterText.value]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("div", _hoisted_29, [
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((requestUrl).value = $event)),
                                        type: "text",
                                        placeholder: "Make a request to a URL",
                                        class: "form-input"
                                    }, null, 512), [
                                        [_vModelText, requestUrl.value]
                                    ]),
                                    _createElementVNode("button", {
                                        class: "btn btn-primary",
                                        onClick: _cache[9] || (_cache[9] = ($event) => (makeRequest(requestUrl.value)))
                                    }, " Go ")
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", {
                        class: _normalizeClass(["card log-card", { 'fullscreen': isFullscreen.value }])
                    }, [
                        _createElementVNode("div", _hoisted_30, [
                            _cache[24] || (_cache[24] = _createElementVNode("h5", { class: "card-title" }, "Cache Log", -1)),
                            _createElementVNode("button", {
                                class: "btn btn-primary btn-fullscreen",
                                onClick: toggleFullscreen
                            }, _toDisplayString(isFullscreen.value ? 'Exit Fullscreen' : 'Fullscreen'), 1)
                        ]),
                        _createElementVNode("pre", _hoisted_31, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredLog.value, (entry, idx) => {
                                return (_openBlock(), _createElementBlock("span", {
                                    key: idx,
                                    innerHTML: highlightHit(entry)
                                }, null, 8, _hoisted_32));
                            }), 128))
                        ])
                    ], 2)
                ])
            ]));
        };
    }
});
